import { FormField } from '../../../types/form-builder.types';
import { cn } from '@shondalai/ui-commons';

interface HeadingFieldProps {
  field: FormField;
}

export function HeadingField({ field }: HeadingFieldProps) {
  const config = field.config;
  
  return (
    <h3 className={cn(
      "text-lg font-medium tracking-tight",
      config.cssClass
    )} style={{ color: 'var(--ef-text, #1E293B)' }}>
      {config.label}
    </h3>
  );
}
